import * as yup from 'yup';

import { translations } from '@/locales';
import { MAX_FILE_SIZE, STRING_LONG_MAX_LENGTH, SUPPORTED_IMAGE_FORMATS } from '@/constants';

export const emailSchema = yup
  .string()
  .email()
  .max(STRING_LONG_MAX_LENGTH)
  .label(translations.inputs.email.label)
  .required();

export const passwordSchema = yup
  .string()
  .min(8)
  .max(STRING_LONG_MAX_LENGTH)
  .label(translations.inputs.password.label)
  .required();

export const firstNameSchema = yup
  .string()
  .max(STRING_LONG_MAX_LENGTH)
  .label(translations.inputs.firstName.label)
  .required();

export const lastNameSchema = yup
  .string()
  .max(STRING_LONG_MAX_LENGTH)
  .label(translations.inputs.lastName.label)
  .required();

export const photoSchema = yup
  .mixed()
  .test({
    name: 'fileSize',
    message: translations.validation.custom.fileSize,
    test: (value) => !value || !value.size || value.size <= MAX_FILE_SIZE
  })
  .test({
    name: 'fileFormat',
    message: translations.validation.custom.fileFormat,
    test: (value) => !value || !value.type || SUPPORTED_IMAGE_FORMATS.includes(value.type)
  });
